import { RequestDetailEvaluator } from './request-detail-evaluator.model';
import { SubjectSelected } from './subject-selected.model';
import { Criteria } from './criteria.model';


export class SavedEvaluation {
    consecutivos: RequestDetailEvaluator[];
    materiasReconocer: SubjectSelected[];
    criterios: Criteria;
}
